// extracted by mini-css-extract-plugin
module.exports = {"duneLogo":"Confetti_duneLogo__Me_22","confetti":"Confetti_confetti__Cn3Xb"};